module.exports = __webpack_public_path__ + "static/media/IndiaImg.2a0b203c.svg";